import { motion } from "framer-motion";
import { quickPickLogo, quickRankLogo } from "@datagame/ui";
import classNames from "classnames/bind";

import { QUICKRANK_RATING_DESTINATION_ID } from "../../../../constants";
import { QuickRankDestination } from "../Destination";
import { QuickRankMode } from "../../../../gql/graphql";
import { QuickRankRenderableDestinations } from "../../../../reducers/quickrank";
import { useQuickRankDestinations } from "../../../../hooks/quickrank/useQuickRankDestinations";

import styles from "./Hand.module.scss";
import { useGlobalConfiguration } from "../../../../hooks/useGlobalConfiugration";

const { HAND, RATED } = QuickRankRenderableDestinations;

const cx = classNames.bind(styles);

export const QuickRankHand = ({ mode, isRating }: { mode: QuickRankMode; isRating: boolean }) => {
  const {
    refs: {
      [RATED]: { ref: ratedRef },
    },
  } = useQuickRankDestinations();
  const { hideDatagameBranding } = useGlobalConfiguration();

  const isTwoPickOne = mode === QuickRankMode.TwoPickN;
  const isQuickPick = mode === QuickRankMode.AllUp;

  return (
    <QuickRankDestination
      styles={styles}
      kind={HAND}
      ref={ratedRef}
      destinationChild={
        <motion.div
          animate={{
            opacity: isRating ? 0 : 1,
          }}
          className={cx("placeholder", { twoPickOne: isTwoPickOne })}
        >
          {!hideDatagameBranding && (
            <img
              className={cx("placeholderImage", { twoPickOne: isTwoPickOne })}
              src={isQuickPick ? quickPickLogo : quickRankLogo}
              alt="QuickRank"
            />
          )}
        </motion.div>
      }
      wrapperChild={<div className={styles.ratingDestination} id={QUICKRANK_RATING_DESTINATION_ID} />}
    />
  );
};
